// extracted by mini-css-extract-plugin
module.exports = {"ttsActions":"PlaySaveActions_ttsActions__3LcBx"};